import Vue from 'vue'
import VimeoPlayer from '@vimeo/player'

export default function ({ app }, inject) {
    inject('vimeoPlayer', VimeoPlayer)
}
